import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage as Translation } from 'react-intl';
import css from './Features.APP_TARGET.scss';
import { XX, WEBP_TYPE } from 'Constants/images';
import { ADPV_EVENTS } from 'Constants/tracking';
import { collapsedFeaturesLimit } from 'Constants/items';
import ImageWrapper from 'Components/ImageWrapper/ImageWrapper';
import { PLATFORM, IS_DESKTOP } from 'Constants/device.APP_TARGET';

export class Features extends React.Component {
    static propTypes = {
        features: PropTypes.array.isRequired,
        onTrack: PropTypes.func
    }

    constructor(props) {
        super(props);
        const featureList = this.props.features.slice(0, collapsedFeaturesLimit[PLATFORM]);

        this.state = {
            featureList,
            expanded: false
        };
    }

    trackViewAll = () => {
        const trackInfo = {
            result_count: this.props.features.length
        };

        this.props.onTrack(ADPV_EVENTS.FEATURE_VIEW_ALL, trackInfo);
    }

    toggleContainer = () => {
        const { expanded } = this.state;

        if (expanded) {
            this.setState({
                expanded: !expanded,
                featureList: this.props.features.slice(0, collapsedFeaturesLimit[PLATFORM])
            });
        }
        else {
            this.trackViewAll();
            this.setState({
                expanded: !expanded,
                featureList: [...this.props.features]
            });
        }
    }

    render() {
        const { featureList, expanded } = this.state;
        const { features } = this.props;

        const showMoreLessComponent = features.length > collapsedFeaturesLimit[PLATFORM]
        && <div className={ css.actionbtn } onClick={ this.toggleContainer }>
            <div className={ css.expand }>
                { expanded ? <Translation id="showLess" /> : <Translation id="showAll" /> }
            </div>
        </div>;

        return (
            <React.Fragment>
                <div className={ css.featureContainer }>
                    <div className={ css.featureHeadingContainer }>
                        <h3 data-aut-id="adFeatureTitle" className={ css.featureHeading }>
                            { <Translation id="features" /> }
                        </h3>
                        { IS_DESKTOP && showMoreLessComponent }
                    </div>
                    { IS_DESKTOP && <div className={ css.separator } /> }
                    <div data-aut-id="featureList" className={ css.featureContent }>
                        {featureList.length > 0
                            && featureList.map((feature, index) => (
                                <div key={ index } className={ css.feature }>
                                    <ImageWrapper
                                        fileName={ feature.imageURI }
                                        fileSize={ XX }
                                        className={ css.img }
                                        types={ WEBP_TYPE } />
                                    <div className={ css.featureName }>
                                        { feature.name }
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                    { !IS_DESKTOP && showMoreLessComponent }
                </div>
            </React.Fragment>
        );
    }
}

export default Features;
